import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { AdminNavEntryPointV2, AdminNavEntryPointV3 } from '@retailer-platform/dashboard/routing'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { approvalManagementAdminRouter } from './routing/approvalsManagementLibraryAdminRouter'
import { accountManagementAccessControl } from './access-control/viewApprovalsManagement'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'approvals-management-library',
  routes,
  translations: { EN_US },
  lazyTranslations: {
    ES_ES: () => import('./translations/es-ES.json'),
    FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    admin: [approvalManagementAdminRouter],
  },
  navigationEntries: [],
  adminNavigationEntries: [
    {
      attachToV2: AdminNavEntryPointV2.Operations,
      attachToV3: AdminNavEntryPointV3.PartnerSettings,
      subNavItems: [
        {
          route: 'app-admin-approvals-management-library-approval-requests-search',
          labelId: 'approvalsManagementLibraryDomain.listPage.title',
          // v3 renames "Search approval requests" → "Approval requests" per
          // Figma; group 3 of v3 Partner settings.
          labelIdV3: 'approvalsManagementLibraryDomain.listPage.title.v3',
          accessControl: accountManagementAccessControl,
          positionNavV3: 8,
        },
      ],
    },
  ],
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'approvals-management-library-dashboard-tool',

    hasDevTooling: false,
  },
}

export default definition
